import { Slot } from "@radix-ui/react-slot";
import classNames from "classnames";

export function MicrositeButton({
  children,
  variant = "primary",
  className,
  asChild = false,
  ...rest
}: {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "red" | "cabovax" | "cabopoc";
  asChild?: boolean;
} & React.ComponentProps<"button">) {
  const Comp = asChild ? Slot : "button";
  const variants = {
    primary: "bg-dynamic-primary text-dynamic-primary-contrast ring-dynamic-primary-contrast ring-1 ",
    secondary: "bg-dynamic-secondary text-dynamic-secondary-contrast",
    red: "bg-red-500 text-white hover:bg-red-600",
    cabovax: "bg-indigo-200 text-white hover:bg-indigo-300 shadow",
    cabopoc: "bg-slate-300 text-white hover:bg-slate-100 shadow",
  };
  return (
    <Comp
      className={classNames(
        "rounded-xl px-8 py-3 transition-all duration-500 hover:brightness-90 disabled:cursor-not-allowed disabled:opacity-50",
        variants[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </Comp>
  );
}
